import Application from "../../Application";
import { IApplicantFormService } from "../../service/form/ApplicantFormService";

export default class UpdateStatusOfAdditionalCheckInteractor {
  private application: Application;
  private applicantFormService: IApplicantFormService;

  constructor(application, applicantFormService) {
    this.application = application;
    this.applicantFormService = applicantFormService;
  }

  async execute(
    applicantReportingPeriodId: number,
    statusAdditionalCheck?: string
  ) {
    return this.applicantFormService.updateStatusOfAdditionalCheck(
      applicantReportingPeriodId,
      statusAdditionalCheck
    );
  }
}
